export enum Provider {
	MICROSOFT = 'microsoft',
	GOOGLE = 'google',
	LOCAL = 'local',
}
